const modalPhotoEditorUserMyAccount = {
  title: 'Edit My Photo'
};

export default modalPhotoEditorUserMyAccount;
